import * as Types from '../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type CurrentYearOfficeBillingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentYearOfficeBillingQuery = { __typename?: 'QueryModel', officeBilling: { __typename?: 'OfficeBillingQueryModel', currentYearSummary?: { __typename?: 'OfficeBillingSummary', year: number, officeCodes: Array<string>, months: Array<{ __typename?: 'OfficeBillingMonthRow', month: number, total: number, amounts: Array<{ __typename?: 'OfficeBillingAmount', officeCode: string, amount: number }> }>, yearToDate: { __typename?: 'OfficeBillingTotalsRow', total: number, amounts: Array<{ __typename?: 'OfficeBillingAmount', officeCode: string, amount: number }> } } | null } };


export const CurrentYearOfficeBillingDocument = gql`
    query CurrentYearOfficeBilling {
  officeBilling {
    currentYearSummary {
      year
      officeCodes
      months {
        month
        amounts {
          officeCode
          amount
        }
        total
      }
      yearToDate {
        amounts {
          officeCode
          amount
        }
        total
      }
    }
  }
}
    `;

/**
 * __useCurrentYearOfficeBillingQuery__
 *
 * To run a query within a React component, call `useCurrentYearOfficeBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentYearOfficeBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentYearOfficeBillingQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentYearOfficeBillingQuery(baseOptions?: Apollo.QueryHookOptions<CurrentYearOfficeBillingQuery, CurrentYearOfficeBillingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentYearOfficeBillingQuery, CurrentYearOfficeBillingQueryVariables>(CurrentYearOfficeBillingDocument, options);
      }
export function useCurrentYearOfficeBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentYearOfficeBillingQuery, CurrentYearOfficeBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentYearOfficeBillingQuery, CurrentYearOfficeBillingQueryVariables>(CurrentYearOfficeBillingDocument, options);
        }
export type CurrentYearOfficeBillingQueryHookResult = ReturnType<typeof useCurrentYearOfficeBillingQuery>;
export type CurrentYearOfficeBillingLazyQueryHookResult = ReturnType<typeof useCurrentYearOfficeBillingLazyQuery>;
export type CurrentYearOfficeBillingQueryResult = Apollo.QueryResult<CurrentYearOfficeBillingQuery, CurrentYearOfficeBillingQueryVariables>;